import * as React from 'react'
import PropTypes from 'prop-types'
import '@tiptap-ui/components/tiptap-ui-primitive/separator/separator.scss'
import { cn } from '@tiptap-ui/lib/tiptap-utils'

export const Separator = React.forwardRef(
  ({ decorative, orientation = 'vertical', className, ...divProps }, ref) => {
    const ariaOrientation = orientation === 'vertical' ? orientation : undefined
    const semanticProps = decorative
      ? { role: 'none' }
      : { 'aria-orientation': ariaOrientation, role: 'separator' }

    return (
      <div
        className={cn('tiptap-separator', className)}
        data-orientation={orientation}
        {...semanticProps}
        {...divProps}
        ref={ref}
      />
    )
  }
)

Separator.displayName = 'Separator'

Separator.propTypes = {
  decorative: PropTypes.bool,
  orientation: PropTypes.oneOf(['vertical', 'horizontal']),
  className: PropTypes.string,
}
